import './BudgetAmountInput.scss'
interface Props {
    value: number
    onChange: (value: number) => void
}
const BudgetAmountInput = (props: Props) => {
    const { value, onChange } = props

    const availableValues = [30,50,100,150,200,250,300,400,500,600,700,800,900,1000].map((v) => v * 100)
    
    return <div className='budget-amount-picker'>
        <div className='available-values'>
            { availableValues.map((availableValue) => {
                return <div
                    className={`available-value ${value === availableValue ? 'selected' : ''}`}
                    onClick={() => onChange(availableValue)}>
                        <div className='gauge'
                            style={{height: `${availableValue / 1000}%`}}
                        />
                        <div className='amount'>{ availableValue / 100}€</div>
                </div>
            })}
        </div>
        <div className='selected-amount'>{ value / 100}€</div>
    </div>
}

export default BudgetAmountInput